import styled from 'styled-components';
import { Text } from '@makemydeal/dr-ui-bricks-components';
import { BreakPoints } from '@makemydeal/dr-ui-bricks-utils';
import { ResponsiveHeading } from '@makemydeal/dr-sales-checkin-components/responsive-heading';

export const StockNumberTypography = styled(ResponsiveHeading)`
    color: #636569;
`;

export const VehicleCardContainer = styled.div`
    display: grid;
    grid-template-columns: auto 1fr;
    grid-template-areas:
        'image header'
        'image deals';
    column-gap: 8px;
    row-gap: 16px;
    align-items: start;
    padding-bottom: 16px;
    background-color: ${({ theme }) => theme.uiBricks.modalBackgroundColor};

    &:not(:last-child) {
        border-bottom: 1px solid #e0e0e0;
    }

    /* Mobile: stock number stacks below the name, radio options drop full-width below the image */
    @media (max-width: ${BreakPoints.PHONE}) {
        grid-template-areas:
            'image header'
            'deals deals';
    }
`;

export const VehicleImageContainer = styled.div`
    grid-area: image;
    width: 108px;
    height: 70px;
    background-color: #f5f5f5;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const VehicleImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 4px;
`;

export const HeaderRow = styled.div`
    grid-area: header;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    min-width: 0;

    @media (max-width: ${BreakPoints.PHONE}) {
        flex-direction: column;
        align-items: flex-start;
        gap: 4px;
    }
`;

export const DealOptionsRow = styled.div`
    display: flex;
    align-items: flex-start;
    grid-area: deals;
    gap: 16px;

    @media (max-width: ${BreakPoints.TABLET}) {
        gap: 4px;
    }

    @media (max-width: ${BreakPoints.PHONE}) {
        flex-direction: column;
        gap: 8px;
    }
`;

export const DealOption = styled.label`
    display: flex;
    align-items: flex-start;
    gap: 4px;
    cursor: pointer;
`;

export const DealOptionRadio = styled.input.attrs({ type: 'radio' })`
    width: 20px;
    height: 20px;
    /* center the 20px control on the label's first line (18px font x 120% line-height) */
    margin: 1px 0 0;
    flex-shrink: 0;
    cursor: pointer;
    accent-color: ${({ theme }) => theme.uiBricks?.primaryAccentColor};

    &:disabled {
        cursor: not-allowed;
    }
`;

export const DealOptionCheckbox = styled.input.attrs({ type: 'checkbox' })`
    width: 18px;
    height: 18px;
    /* center the 18px control on the label's first line (18px font x 120% line-height) */
    margin: 2px 0 0;
    flex-shrink: 0;
    cursor: pointer;
    accent-color: ${({ theme }) => theme.uiBricks?.primaryAccentColor};

    &:disabled {
        cursor: not-allowed;
    }
`;

export const DealOptionInfo = styled.div`
    display: flex;
    flex-direction: column;
    color: ${({ theme }) => theme.uiBricks.labelFontColor};
`;

export const DealOptionLabel = styled(Text)`
    color: ${({ theme }) => theme.uiBricks.labelFontColor};
`;

export const DealOptionDate = styled(Text)`
    color: #727479;
`;
